import script from "./Tableu.vue?vue&type=script&setup=true&lang=js"
export * from "./Tableu.vue?vue&type=script&setup=true&lang=js"

import "./Tableu.vue?vue&type=style&index=0&id=694ef1ba&scoped=true&lang=scss"

import exportComponent from "D:\\DongLK\\Project\\ytbot\\controller-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-694ef1ba"]])

export default __exports__